const columnVisibilityModelAssetTracker = {
    id: true,
    alert: true,
    moment_status: true,
    moment_status_duration: true,
    name: true,
    identifier: true,
    speed: true,
    battery_level: true,
    external_powersource_status: true,
    engine_ignition_status: true,
    fuel_level: true,
    rpm: true,
    location: true,
    entity: true,
    entity_address_name: true,
    item: true,
    address: true,
    city: true,
    state: true,
    postal_code: true,
    lat: true,
    long: true,
    last_updated: true,
};
const columnVisibilityModelLevelMonitor = {
    id: true,
    alert: true,
    name: true,
    identifier: true,
    percent_level: true,
    volume_level: true,
    ullage_volume: true,
    entity: true,
    entity_address_name: true,
    item: true,
    address: true,
    city: true,
    state: true,
    postal_code: true,
    lat: true,
    long: true,
    last_updated: true,
    inch_level: true,
    battery_voltage: true,
    wifi_signal: true,
    last24h_percent: true,
    last24h_level: true,
    last24h_volume: true,
    ai_trend: true,
    ai_status: true,
};
const columnVisibilityModelHolyKel = {
    id: true,
    alert: true,
    name: true,
    identifier: true,
    percent_level: true,
    psi: true,
    job_state: true,
    volume_level: true,
    ullage_volume: true,
    entity: true,
    entity_address_name: true,
    item: true,
    address: true,
    city: true,
    state: true,
    postal_code: true,
    lat: true,
    long: true,
    last_updated: true,
    fluid_height: true,
    calibrated_level: true,
    usable_height: true,
    raw_level: true,
    last24h_percent: true,
    last24h_level: true,
    last24h_volume: true,
    ai_trend: true,
    ai_status: true
};
const columnVisibilityModelTablet = {
    id: true,
    alert: true,
    name: true,
    identifier: true,
    percent_level: true,
    psi: true,
    volume_gallons: true,
    gallons_remaining: true,
    moment_status: true,
    speed: true,
    vehicle_connected: true,
    active_fault_count: true,
    entity: true,
    entity_address_name: true,
    item: true,
    address: true,
    city: true,
    state: true,
    postal_code: true,
    lat: true,
    long: true,
    last_updated: true,
};

export {
    columnVisibilityModelAssetTracker,
    columnVisibilityModelHolyKel,
    columnVisibilityModelLevelMonitor,
    columnVisibilityModelTablet
}